var WARNING_COPY = 'Initializing an SDK without passing in a ServiceSDK is deprecated. Please pass in a ServiceSDK.';
export default function () {
  if (console) {
    // eslint-disable-next-line no-console -- directive added automatically by Shepherd migration
    if (console.warn) {
      // eslint-disable-next-line no-console -- directive added automatically by Shepherd migration
      console.warn(WARNING_COPY);
    } // eslint-disable-next-line no-console -- directive added automatically by Shepherd migration
    else if (console.log) {
        // eslint-disable-next-line no-console -- directive added automatically by Shepherd migration
        console.log(WARNING_COPY);
      }
  }
}